<template>
  <CTable v-if="Array.isArray(statisticsData)" class="border">
    <CTableHead color="secondary">
      <CTableRow  class="flex">
        <CTableHeaderCell scope="col"  class="flex-1">答案選項</CTableHeaderCell>
        <CTableHeaderCell
          v-show="(questionType === $defines.ItemTypes.ItemSort)"
          v-for="(item, index) in statisticsData[0].order"
          :key="item"
          scope="col"
          class="flex-1"
          >排序{{ index + 1 }}</CTableHeaderCell
        >
        <CTableHeaderCell scope="col"  class="flex-1">填答數</CTableHeaderCell>
        <CTableHeaderCell v-if="(questionType !== $defines.ItemTypes.ItemSort)" scope="col"  class="flex-1"
          >百分比</CTableHeaderCell
        >
      </CTableRow>
    </CTableHead>
    <CTableBody>
      <CTableRow v-for="item in statisticsData" :key="item" class="flex">
        <CTableDataCell scope="col" class="flex-1">{{ item.title || item.star }}</CTableDataCell>
        <CTableDataCell scope="col"  class="flex-1" v-for="order in item.order" :key="order">
          {{ order }}
        </CTableDataCell>
        <CTableDataCell scope="col"  class="flex-1">{{ item.count }}</CTableDataCell>
        <CTableDataCell
          v-if="
            questionType !== $defines.ItemTypes.ItemSort && (item.percentage || item.percentage === 0)
          "
          scope="col"  class="flex-1">{{ item.percentage.toFixed(2) }} %</CTableDataCell
        >
      </CTableRow>
    </CTableBody>
  </CTable>
  <CTable v-else class="border">
    <CTableHead color="secondary">
      <CTableRow class="flex">
        <CTableHeaderCell class="flex-1" scope="col">計算單位</CTableHeaderCell>
        <CTableHeaderCell class="flex-1" scope="col">結果</CTableHeaderCell>
      </CTableRow>
    </CTableHead>
    <CTableBody>
      <CTableRow
        v-show="name !== 'all'"
        v-for="(item, name) in statisticsData"
        :key="item"
        class="flex"
      >
        <CTableDataCell  class="flex-1">{{ list[name] }}</CTableDataCell>
        <CTableDataCell  class="flex-1">{{ item }}</CTableDataCell>
      </CTableRow>
    </CTableBody>
  </CTable>
</template>
<script>
import { ref } from '@vue/reactivity'
export default {
  props: {
    statisticsData: {
      type: [Object, Array],
      default: () => [{}],
    },
    questionType: {
      type: String,
      default: '',
    },
  },
  setup() {
    const list = ref({
      mode: '眾數',
      average: '平均數',
      median: '中位數',
      min: '最小值',
      max: '最大值',
      standard_deviation: '標準差',
      total: '填答總和',
    })
    return {
      list,
    }
  },
}
</script>
<style lang="scss" scoped>
.flex{
  display: flex;
  align-items: center;
}
.flex-1{
  flex:1;
  text-align: center;
}
.flex .flex-1:first-child{
  text-align: left;
}
/* .flex .flex-1:last-child{
  text-align: right;
} */
</style>
